/**
 * Top 5 Risques : catégories de Findings les plus fréquentes.
 */
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CHARTS } from "@/constants/testIds";

export default function TopRisksChart({ data = [] }) {
  return (
    <Card data-testid={CHARTS.topRisks} className="border-slate-200 shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold uppercase tracking-wider text-slate-500">Top 5 Risques</CardTitle>
      </CardHeader>
      <CardContent className="h-[280px] pt-0">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ left: 10 }}>
            <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E2E8F0" />
            <XAxis type="number" tick={{ fontSize: 11, fill: "#64748B" }} />
            <YAxis
              type="category"
              dataKey="category"
              width={160}
              tick={{ fontSize: 11, fill: "#64748B" }}
              tickFormatter={(value) => (value && value.length > 24 ? `${value.slice(0, 24)}…` : value)}
            />
            <Tooltip contentStyle={{ borderRadius: 8, borderColor: "#E2E8F0", fontSize: 12 }} labelFormatter={(label) => label} />
            <Bar dataKey="count" fill="#0B5394" radius={[0, 4, 4, 0]} barSize={18} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
